export const TAG_TYPES = {
  DEFAULT: 'default'
}
